export const langText: any = {
    us: {
        OFF: 'OFF',
        title: 'Discount code',
        desc: ' EcoCredirs',
        rules: 'Rules',
    },
    jp: {
        rules: '条件',
    },
    de: {
        rules: 'Regeln',
    },
    fr: {
        rules: 'Règles',
    },
    it: {
        rules: 'Regole',
    },
    es: {
        rules: 'Reglas',
    },
    kr: {
        rules: '포인트 사용 규칙',
    },
    br: {
        OFF: 'OFF',
        title: 'Código de desconto',
        desc: ' EcoCredirs',
        rules: 'Regras',
    },
    mx: {
        OFF: 'OFF',
        title: 'Código de descuento',
        desc: ' EcoCredirs',
        rules: 'Reglas',
    },
    nl: {
        OFF: 'KORTING',
        title: 'Kortingscode',
        desc: ' EcoCredits',
        rules: 'Regels',
    },
};
